import { createContext, ReactNode } from 'react';
import useThunkReducer, { ThunkDispatch } from 'react-hook-thunk-reducer';

import initialState, { TInitialState } from './initialState';
import { reducer, TAction } from './reducer';

export type TContextDispatch = ThunkDispatch<TInitialState, TAction>;

export type TContext = {
    state: TInitialState,
    dispatch: TContextDispatch,
    debugMode?: boolean,
    showSurvey?: boolean,
};

export const Ctx = createContext<TContext>({
    state: initialState,
    dispatch: () => null,
    debugMode: false,
    showSurvey: false,
});

interface IContextProps {
    children: ReactNode,
    showSurvey?: boolean,
    debugMode?: boolean,
}

const PopupGroupContext = ({ children, showSurvey = false, debugMode = false }: IContextProps): JSX.Element => {
    const [state, dispatch] = useThunkReducer<TInitialState, TAction>(reducer, initialState);

    debugMode && console.log(state);

    return (
        <Ctx.Provider value={{ state, dispatch, debugMode, showSurvey }}>
            {children}
        </Ctx.Provider>
    );
};

export default PopupGroupContext;
